// extracted by mini-css-extract-plugin
export default {"username":"user-information_username__m23FP","iconBox":"user-information_iconBox__E1Bdf"};